import React from 'react';
import useStyles from "../products/styles";
import { Snackbar, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const SnackbarMessage = ({ showSnackbar, messageSnackbar, handleToClose, isError }) => {
    const classes = useStyles();

    return (
        <Snackbar
        anchorOrigin={{
          horizontal: "left",
          vertical: "bottom",
        }}
        open={showSnackbar}
        autoHideDuration={2000}
        message={messageSnackbar}
        onClose={handleToClose}
        ContentProps={{
          className: !isError ? classes.snackbarStyleViaContentProps : classes.snackbarStyleViaContentPropsError
        }}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleToClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    );
}

export default SnackbarMessage;
